import { render, staticRenderFns } from "./RouteAssessmentMetricsReportForm.vue?vue&type=template&id=3c06a1a2&scoped=true&"
import script from "./RouteAssessmentMetricsReportForm.vue?vue&type=script&lang=js&"
export * from "./RouteAssessmentMetricsReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06a1a2",
  null
  
)

export default component.exports